import Logger from 'utils/logger'

const csrf_token = () => {
  const csrf_token_element = document.querySelector('meta[name="csrf-token"]')
  return csrf_token_element ? csrf_token_element.content : null
}

const filenameFromHeaders = (headers) => {
  const contentDisposition = headers.get('Content-Disposition') || ''
  const match = contentDisposition.match(
    /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
  )
  const filename = match ? decodeURIComponent(match[1] || match[2]) : 'download'
  return filename
}

const downloadResponseBlob = async (response) => {
  const blobBody = await response.blob()
  const filename = filenameFromHeaders(response.headers)
  const objectUrl = window.URL.createObjectURL(blobBody)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = filename
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(objectUrl)
}

const apiRequest = async ({
  method,
  url,
  payload,
  requestDescription,
  reloadOnAuthError = true,
  responseType = 'json',
}) => {
  try {
    const response = await fetch(request(method, url, payload))

    if (response.redirected) {
      window.location = response.url
      return {
        ok: response.ok,
        status: response.status,
        body: {},
      }
    } else if (response.status === 401 || response.status === 403) {
      // `reload(true)` causes the page to always be reloaded from the server,
      // rather than from browser cache
      // Reloading page from server triggers reauthentication if necessary
      if (reloadOnAuthError) {
        window.location.reload(true)
        return {
          ok: false,
          status: response.status,
          body: {},
        }
      } else {
        return {
          ok: response.ok,
          status: response.status,
          body: {},
        }
      }
    } else {
      let jsonBody = {}

      if (responseType === 'blob') {
        if (response.ok) {
          downloadResponseBlob(response)
        }

        return {
          ok: response.ok,
          status: response.status,
          body: {},
        }
      }

      try {
        jsonBody = await response.json()
      } catch {
        // No-op.
      }

      return {
        ok: response.ok,
        status: response.status,
        body: jsonBody,
      }
    }
  } catch (error) {
    if (error instanceof Error) {
      Logger.error(error)
      throw new Error(
        `There was a problem while ${requestDescription}. Are you connected to the internet?`
      )
    }

    throw error
  }
}

const request = (method, url, payload) => {
  const headers = new Headers()
  headers.set('X-CSRF-Token', csrf_token())
  headers.set('Content-Type', 'application/json')

  const options = {
    method: method,
    headers: headers,
    credentials: 'same-origin',
    redirect: 'follow',
  }

  const body =
    method.toLowerCase() === 'get' || method.toLowerCase() === 'head'
      ? {}
      : {
          body: JSON.stringify(payload),
        }

  return new Request(url, { ...options, ...body })
}

export default apiRequest
